import {faTv, faTrash, faFilm, faVideo, faHardDrive, faClock, faXmark, faCheck, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useEffect, useState} from 'react';
import Select from 'react-select';
import {getSeriesForSelect, getMoviesForSelect, deleteVideo, assignVideoToSerie, assignVideoToMovie} from '../../../../api';
import {lookupVideoAssignment} from '../../../../api/videoServers';
import Player from '../../../../common/Player';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {swalConfig, toastConfig} from '../../../../config';
import {toast} from 'react-toastify';

const Video = ({data, currentPath, serverId, removeVideo}) => {
    const mySwal = withReactContent(Swal);
    const [assigning, setAssigning] = useState(false);
    const [assignment, setAssignment] = useState(undefined);

    // Serie
    const [serie, setSerie] = useState({});
    const [season, setSeason] = useState('');
    const [episode, setEpisode] = useState('');

    // Movie
    const [movie, setMovie] = useState({});

    const [options] = useState({
        controls: true,
        autoplay: false,
        sources: {src: data.url},

        poster: data.thumbnail,
        updated: false,
    });

    const [seriesOptions, setSeriesOptions] = useState([]);
    const [moviesOptions, setMoviesOptions] = useState([]);

    let sizeInMb = data.size / 1000000;
    sizeInMb = Math.round(sizeInMb * 100) / 100;

    const refreshAssignment = () => {
        setAssignment(undefined);
        lookupVideoAssignment(data.url).then((res) => setAssignment(res.data));
    };

    useEffect(() => {
        refreshAssignment();
    }, []);

    useEffect(() => {
        if (assigning === 'serie') {
            getSeriesForSelect().then((res) => {
                setSeriesOptions(res.data.series.map((s) => ({value: s._id, label: s.titulo_original})));
            });
        } else if (assigning === 'movie') {
            getMoviesForSelect().then((res) => {
                setMoviesOptions(res.data.movies.map((m) => ({value: m._id, label: m.titulo_original})));
            });
        }
    }, [assigning]);

    const handleDelete = async () => {
        const res = await mySwal.fire({...swalConfig.confirm, text: `Estás borrando "${data.name}"`});
        if (res.isConfirmed) {
            deleteVideo({serverId, filename: data.name, filepath: currentPath.join('/')}).then(() => {
                toast.success('Video borrado', toastConfig);
                removeVideo(data.name);
            });
        }
    };

    const confirmAssign = async () => {
        try {
            if (assigning === 'serie') {
                const res = await mySwal.fire({
                    ...swalConfig.confirm,
                    text: `Estás asignando "${data.name}" a la serie ${serie.label}, temporada ${season} y capítulo ${episode}.`,
                });
                if (res.isConfirmed) {
                    await assignVideoToSerie({serieId: serie.value, video: data.url, thumbnail: data.thumbnail, season, episode});
                    toast.success('Video asignado', toastConfig);
                    setAssigning(false);
                    setSerie({});
                    setSeason('');
                    setEpisode('');
                    refreshAssignment();
                }
            } else if (assigning === 'movie') {
                const res = await mySwal.fire({
                    ...swalConfig.confirm,
                    text: `Estás asignando "${data.name}" a la película ${movie.label}.`,
                });
                if (res.isConfirmed) {
                    await assignVideoToMovie({movieId: movie.value, video: data.url, thumbnail: data.thumbnail});
                    toast.success('Video asignado', toastConfig);
                    setAssigning(false);
                    setMovie(null);
                    refreshAssignment();
                }
            }
        } catch (err) {
            console.log(err);
            toast.error('Error al asignar video', toastConfig);
        }
    };

    return (
        <div className='bg-white border border-gray-200 shadow-sm rounded-xl overflow-hidden'>
            <div className='flex md:flex-row flex-col'>

                {/* Player — fills the full card height via flex stretch */}
                <div className='md:w-[265px] w-full flex-shrink-0 [&>div]:!rounded-none [&>div]:!aspect-auto [&>div]:h-full'>
                    {options?.sources && <Player options={options} onReady={() => {
                    }} style={{fontSize: '10px'}}/>}
                </div>

                {/* Info */}
                <div className='flex-1 flex flex-col p-4 gap-4 min-w-0'>

                    {/* Filename */}
                    <div className='flex items-center gap-2 min-w-0'>
                        <FontAwesomeIcon icon={faVideo} className='text-red-1 flex-shrink-0 text-sm'/>
                        <span className='text-gray-900 font-semibold text-sm truncate'>{data.name}</span>
                    </div>

                    {/* Metadata chips */}
                    <div className='flex flex-wrap gap-2'>
            <span className='inline-flex items-center gap-1.5 bg-gray-100 text-gray-500 text-xs font-medium px-2.5 py-1 rounded-full'>
              <FontAwesomeIcon icon={faHardDrive} className='text-gray-400 text-[10px]'/>
                {sizeInMb} MB
            </span>
                        <span className='inline-flex items-center gap-1.5 bg-gray-100 text-gray-500 text-xs font-medium px-2.5 py-1 rounded-full'>
              <FontAwesomeIcon icon={faClock} className='text-gray-400 text-[10px]'/>
                            {new Date(data.createdOn).toISOString().slice(0, 10)}
            </span>

                        {assignment === undefined && (
                            <span className='inline-flex items-center gap-1.5 bg-gray-100 text-gray-400 text-xs font-medium px-2.5 py-1 rounded-full'>
                <FontAwesomeIcon icon={faSpinner} className='animate-spin text-[10px]'/>
                Verificando...
              </span>
                        )}
                        {assignment?.type === 'serie' && (
                            <a
                                href={`/series/${assignment.serie.url}/${assignment.episode.numero}`}
                                target='_blank'
                                rel='noreferrer'
                                className='inline-flex items-center gap-1.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs font-semibold px-2.5 py-1 rounded-full hover:bg-blue-100 transition-colors'
                            >
                                <FontAwesomeIcon icon={faTv} className='text-[10px]'/>
                                {assignment.serie.titulo_original} · S{assignment.episode.temporada} EP{assignment.episode.numero}
                            </a>
                        )}
                        {assignment?.type === 'movie' && (
                            <a
                                href={`/peliculas/${assignment.movie.url}`}
                                target='_blank'
                                rel='noreferrer'
                                className='inline-flex items-center gap-1.5 bg-purple-50 border border-purple-200 text-purple-700 text-xs font-semibold px-2.5 py-1 rounded-full hover:bg-purple-100 transition-colors'
                            >
                                <FontAwesomeIcon icon={faFilm} className='text-[10px]'/>
                                {assignment.movie.titulo_original}
                            </a>
                        )}
                        {assignment?.type === null && (
                            <span className='inline-flex items-center bg-amber-50 border border-amber-200 text-amber-600 text-xs font-semibold px-2.5 py-1 rounded-full'>
                Sin asignar
              </span>
                        )}
                    </div>

                    {/* Actions */}
                    <div className='mt-auto pt-2 border-t border-gray-100'>

                        {/* Default action row */}
                        {!assigning && (
                            <div className='flex items-center justify-between gap-2'>
                                <div className='flex gap-2'>
                                    <button
                                        onClick={() => setAssigning('serie')}
                                        className='inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-red-1 text-white hover:bg-red-1/90 transition-colors'
                                    >
                                        <FontAwesomeIcon icon={faTv}/>
                                        Asignar serie
                                    </button>
                                    <button
                                        onClick={() => setAssigning('movie')}
                                        className='inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-red-1 text-white hover:bg-red-1/90 transition-colors'
                                    >
                                        <FontAwesomeIcon icon={faFilm}/>
                                        Asignar película
                                    </button>
                                </div>
                                <button
                                    onClick={handleDelete}
                                    className='inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border border-red-200 text-red-1 hover:bg-red-1 hover:text-white transition-colors'
                                >
                                    <FontAwesomeIcon icon={faTrash}/>
                                    Borrar
                                </button>
                            </div>
                        )}

                        {/* Serie assign form */}
                        {assigning === 'serie' && (
                            <div className='flex flex-wrap items-center gap-2'>
                                <label className='text-xs font-semibold text-gray-500'>Serie</label>
                                <Select
                                    isSearchable
                                    options={seriesOptions}
                                    value={serie}
                                    onChange={(v) => setSerie(v)}
                                    className='w-44 text-xs'
                                    menuPortalTarget={document.body}
                                    menuPosition='fixed'
                                />
                                <label className='text-xs font-semibold text-gray-500'>Temp.</label>
                                <input
                                    type='text'
                                    className='text-center text-xs outline-none focus:ring-1 focus:ring-red-2 rounded-lg p-1.5 w-10 border border-gray-200'
                                    value={season}
                                    onChange={(e) => setSeason(e.target.value)}
                                />
                                <label className='text-xs font-semibold text-gray-500'>Cap.</label>
                                <input
                                    type='text'
                                    className='text-center text-xs outline-none focus:ring-1 focus:ring-red-2 rounded-lg p-1.5 w-10 border border-gray-200'
                                    value={episode}
                                    onChange={(e) => setEpisode(e.target.value)}
                                />
                                <button
                                    onClick={confirmAssign}
                                    hidden={!serie?.value || !season || !episode}
                                    className='inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors'
                                >
                                    <FontAwesomeIcon icon={faCheck}/>
                                    Asignar
                                </button>
                                <button
                                    onClick={() => setAssigning(false)}
                                    className='inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-100 transition-colors'
                                >
                                    <FontAwesomeIcon icon={faXmark}/>
                                    Cancelar
                                </button>
                            </div>
                        )}

                        {/* Movie assign form */}
                        {assigning === 'movie' && (
                            <div className='flex flex-wrap items-center gap-2'>
                                <label className='text-xs font-semibold text-gray-500'>Película</label>
                                <Select
                                    isSearchable
                                    options={moviesOptions}
                                    value={movie}
                                    onChange={(v) => setMovie(v)}
                                    className='w-44 text-xs'
                                    menuPortalTarget={document.body}
                                    menuPosition='fixed'
                                />
                                <button
                                    onClick={confirmAssign}
                                    hidden={!movie?.value}
                                    className='inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors'
                                >
                                    <FontAwesomeIcon icon={faCheck}/>
                                    Asignar
                                </button>
                                <button
                                    onClick={() => setAssigning(false)}
                                    className='inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-100 transition-colors'
                                >
                                    <FontAwesomeIcon icon={faXmark}/>
                                    Cancelar
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Video;
